export const app = {
  search: "Chercher",
};
